import { Icon } from '@sakhtar/design-system/react';
import { faDigits } from '../../lib/faDigits.js';

/** «نمایش ۱ تا ۲۰ از ۳۲» + page buttons (Sales CRM design, list footer). */
export function Pagination({
  offset,
  limit,
  total,
  onOffset,
}: {
  offset: number;
  limit: number;
  total: number;
  onOffset: (offset: number) => void;
}) {
  if (total === 0) return null;
  const pages = Math.max(1, Math.ceil(total / limit));
  const current = Math.floor(offset / limit) + 1;
  const first = Math.max(1, Math.min(current - 2, pages - 4));
  const shown = Array.from({ length: Math.min(5, pages) }, (_, i) => first + i);
  const from = offset + 1;
  const to = Math.min(offset + limit, total);
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        padding: '12px 16px',
        borderTop: '1px solid var(--sk-divider)',
        flexWrap: 'wrap',
      }}
    >
      <span style={{ fontSize: 13, color: 'var(--sk-fg-muted)' }}>
        نمایش {faDigits(from)} تا {faDigits(to)} از {faDigits(total)}
      </span>
      {pages > 1 ? (
        <nav aria-label="صفحه‌بندی" style={{ display: 'flex', gap: 4 }}>
          <button
            type="button"
            className="sk-btn sk-btn--secondary sk-btn--sm sk-btn--icon"
            aria-label="صفحهٔ قبل"
            disabled={current === 1}
            onClick={() => onOffset(Math.max(0, offset - limit))}
          >
            <Icon name="chevronRight" size="sm" />
          </button>
          {shown.map((page) => (
            <button
              key={page}
              type="button"
              aria-current={page === current ? 'page' : undefined}
              className={`sk-btn sk-btn--sm ${page === current ? 'sk-btn--primary' : 'sk-btn--ghost'}`}
              style={{ minWidth: 28, padding: '0 6px' }}
              onClick={() => onOffset((page - 1) * limit)}
            >
              {faDigits(page)}
            </button>
          ))}
          <button
            type="button"
            className="sk-btn sk-btn--secondary sk-btn--sm sk-btn--icon"
            aria-label="صفحهٔ بعد"
            disabled={current === pages}
            onClick={() => onOffset(offset + limit)}
          >
            <Icon name="chevronLeft" size="sm" />
          </button>
        </nav>
      ) : null}
    </div>
  );
}
